import {Badge, Card} from 'antd';
import {NOTIFICATION} from './notifications.type';

const NotificationCard = ({data}: {data: NOTIFICATION}) => {
  return data.is_read === false ? (
    <div style={{marginBlock: '10px'}}>
      <Badge.Ribbon text='New' color='red'>
        <Card
          size='small'
          bordered={false}
          style={{
            borderRadius: '10px',
            boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px',
          }}
        >
          <h5>{data.asset_id}</h5>
          <h5>{data.event[0]}</h5>
          <h5> {data.event_time}</h5>
        </Card>
      </Badge.Ribbon>
    </div>
  ) : (
    <div style={{marginBlock: '10px'}}>
      <Card
        size='small'
        bordered={false}
        style={{
          borderRadius: '10px',
          boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px',
        }}
      >
        <h5>{data.asset_id}</h5>
        <h5>{data.event}</h5>
        <h5> {data.event_time}</h5>
      </Card>
    </div>
  );
};

export default NotificationCard;
